import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { supportService } from '../services/support.service';
import { SupportRequestData } from '../types/support.types';

interface UseSupportRequestOptions {
  onSuccess?: () => void;
}

export const useSupportRequest = (options?: UseSupportRequestOptions) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (data: SupportRequestData) => supportService.sendRequest(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['support', 'tickets'] });
      toast.success(
        t(
          'support.success',
          'Votre demande de support a été envoyée avec succès'
        )
      );
      options?.onSuccess?.();
    },
    onError: (error: HttpApiError) => {
      console.error('Support request error:', error);
      toast.error(
        t(
          'support.error',
          "Erreur lors de l'envoi de votre demande. Veuillez réessayer."
        )
      );
    },
  });

  return {
    sendSupportRequest: mutation.mutate,
    isLoading: mutation.isPending,
    error: mutation.error,
  };
};
